function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#A5ACB0",
  d: "M23 72h2v-8h-2zM55 72h2v-8h-2zM67 72h-2V59c0-5.222-4.084-6.975-10.316-9.052C50.266 48.477 45 46.249 45 44v-7h2v7c.294.746 4.185 2.674 8.316 4.052C60.793 49.877 67 51.946 67 59v13M15 72h-2V59c0-7.054 6.207-9.123 11.684-10.948 4.131-1.378 8.022-3.306 8.326-4.124L33 37h2v7c0 2.249-5.266 4.477-9.684 5.948C19.084 52.025 15 53.778 15 59v13"
}), React.createElement("path", {
  d: "M32 22.899V25c0 8.025 1.338 13 8 13s8-4.975 8-13v-3.355C46.628 22.259 44.461 23 42 23c-2.893 0-5.382-.913-6.784-2.313A5.012 5.012 0 0132 22.899zM40 40c-10 0-10-10.131-10-15v-3a1 1 0 011-1c1.654 0 3-1.346 3-3a1 1 0 112 0c0 1.419 2.464 3 6 3 3.533 0 6.433-1.824 6.462-1.843A1.001 1.001 0 0150 20v5c0 4.869 0 15-10 15zM48 41v-2c3.86 0 7-3.141 7-7 0-1.329-.291-2.507-.866-3.499l1.732-1.002C56.618 28.8 57 30.314 57 32c0 4.963-4.038 9-9 9",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M52 31v-2c2.154 0 4-2.749 4-5s-1.846-5-4-5a1 1 0 01-1-1c0-4.71-3.701-8-9-8h-4c-5.299 0-9 3.29-9 8a1 1 0 01-1 1c-2.154 0-4 2.749-4 5s1.846 5 4 5v2c-3.379 0-6-3.763-6-7 0-2.922 2.136-6.273 5.038-6.897C27.489 11.776 31.96 8 38 8h4c6.04 0 10.511 3.776 10.962 9.103C55.864 17.727 58 21.078 58 24c0 3.237-2.621 7-6 7",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M32 41c-4.962 0-9-4.037-9-9 0-1.686.382-3.2 1.134-4.501l1.732 1.002C25.291 29.493 25 30.671 25 32c0 3.859 3.14 7 7 7v2M40 64c-.139 0-.279-.029-.409-.087C39.077 63.683 27 58.192 27 51v-3h2v3c0 4.706 7.583 9.281 11 10.898 3.417-1.62 11-6.199 11-10.898v-3h2v3c0 7.192-12.077 12.683-12.591 12.913-.13.058-.27.087-.409.087",
  fill: "#A5ACB0"
}), React.createElement("path", {
  fill: "#EA7125",
  d: "M33 49h2v-2h-2zM36 50h2v-2h-2zM39 51h2v-2h-2zM39 54h2v-2h-2zM42 50h2v-2h-2zM45 49h2v-2h-2z"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationWomanNecklace = function SvgIconIllustrationWomanNecklace(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationWomanNecklace;